<template>
    <v-card>
        <v-row class="input-row">
            <v-col class="py-0">
                <div class="xlsx-preview body-2">
                    <table
                        cellspacing="0"
                        cellpadding="0"
                        border="0"
                        class="elevation-0"
                    >
                        <thead>
                            <tr>
                                <td
                                    v-for="(headerObj, idx) in controller.model.getHeaders()"
                                    :key="idx"
                                    :class="[
                                        idx === 0 ? 'no-row' : 'pb-1 px-0 header-select-td',
                                        controller.model.getAvailableFieldParsers().filter(x => x.uku_key === headerObj.uku_key).length ? 'header-selected-td' : ''
                                    ]"
                                >
                                    <span v-if="idx > 0" class="header-select">
                                        <dropdown
                                            :items="controller.model.getAvailableFieldParsers()"
                                            :selected="controller.model.getAvailableFieldParsers().filter(x => x.uku_key === headerObj.uku_key)"
                                            :placeholder="$t('Select')"
                                            name-key="title"
                                            value-key="uku_key"
                                            show-selected-first
                                            :outlined="false"
                                            deselect
                                            @input="controller.mapped_column_changed(headerObj.column, $event.uku_key)"
                                        />
                                    </span>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(row, row_idx) in controller.model.getPreviewData()"
                                :key="row_idx"
                            >
                                <td
                                    v-for="(val, cell_idx) in row"
                                    :key="cell_idx"
                                    :class="
                                        cell_idx === 0
                                            ? 'header-no-row'
                                            : row_idx <
                                                controller.model.getImportFromRow() +
                                                1
                                                ? 'header-row'
                                                : ''
                                    "
                                    :align="
                                        cell_idx === 0
                                            ? 'center'
                                            : row_idx <
                                                controller.model.getImportFromRow() +
                                                1
                                                ? 'center'
                                                : typeof val === 'object'
                                                    ? 'right'
                                                    : 'left'
                                    "
                                >
                                    <template v-if="row_idx === 0 || cell_idx === 0">
                                        <span v-if="typeof val === 'object'">
                                            {{ val.title }}
                                        </span>
                                        <span v-else>
                                            {{ val }}
                                        </span>
                                    </template>
                                    <template v-else>
                                        <span v-if="val === null"></span>
                                        <span v-else-if="typeof val === 'string' || typeof val == 'number' || typeof val === 'boolean'">
                                            {{ val }}
                                        </span>
                                        <span
                                            v-else-if="val.type === 'datetime'">
                                            {{ val.value | format_datetime }}
                                        </span>
                                        <span v-else-if="val.type === 'date'">
                                            {{ val.value | format_date }}
                                        </span>
                                        <span v-else-if="val.type === 'time'">
                                            {{ val.value | format_time }}
                                        </span>
                                        <span v-else-if="val.type === 'boolean'">
                                            {{ val.value | format_bool }}
                                        </span>
                                        <span v-else>
                                            {{ val.value }}
                                        </span>
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import Controller from "./controller";

export default {
    name: "ImporterSettingsViewPreview",
    props: {
        controller: {
            type: Controller,
            required: true
        }
    }
};
</script>
<style scoped lang="scss">

.header-select-td {
    border-left: 1px solid var(--v-white-base) !important;
    background-color: var(--v-n4-base);

    &.header-selected-td {
        background-color: var(--v-tretiary-darken1);
    }

    .header-select ::v-deep .v-input {
        padding-top: 0;
        margin-top: 0;

        .v-input__slot {
            &::before, &::after {
                display: none;
            }

            input {
                padding-left: 12px;
                font-size: 14px !important;
                color: var(--v-white-base) !important;
                max-height: 30px !important;

                &::placeholder {
                    color: var(--v-white-base);
                }
            }

            .v-icon {
                color: var(--v-white-base) !important;
            }
        }
    }
}
</style>